import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import Template from '../Template';
import TemplateViewOnly from '../TemplateViewOnly';
import SearchTemplate from '../SearchTemplate';
import Tooltip from '../../Tooltip';
import DesignOptionFilters from '../DesignOptionFilters';
import Warning from './Warning';
export const FunctionalGroup = ({
  functionalOptionCodeMappings,
  functionalGroupCodes,
  formatUpcharge,
  unitsString,
  visibleTemplateIds,
  quantityString,
  designPackageString,
  priceBrandString,
  totalPriceString,
  suggestedString,
  priorityHeader,
  modelId,
  inReviewView,
  submittedTemplateIds,
  functionalGroupQuantity,
  hasSubmittedTemplates,
  noSubmittedTemplatesNotice,
  duplicateTemplateId,
  hasDuplicate,
  hasInReviewTemplates,
  noInReviewTemplatesNotice,
  searchView,
  matchingSearchTemplates,
  mini,
  toggleDescription,
  handleMouseOver,
  handleMouseLeave,
  isOpen,
  functionalGroupId,
  functionalGroupTemplates,
  isInViewport,
  onSearchWithinGroup,
  isWarningVisible,
  hideWarning,
  clearGlobalFilters,
  areFiltersVisible,
  onRemoveFilter,
  designOptions,
  activeFilters,
  noSearchResultsNotice,
}) => {
  let i = 0;
  let countFunctionalCode = functionalGroupCodes.length;
  return (
    <div className={styles.functionalGroup}>
      <div className={styles.header}>
        <span className={styles.codes}>
          <span
            onClick={toggleDescription}
            onMouseEnter={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            className={styles.marginIcon}
          >
            <Tooltip data-test="tooltip" />
          </span>
          {functionalGroupCodes.map(code => (
            <span key={code} className={styles.code}>
              {code}
            </span>
          ))}
        </span>
        {isOpen && (
          <div className={styles.codeBox}>
            {functionalGroupCodes.map(code => (
              <span key={code} className={styles.code}>
                <span className={styles.textCode}>{code}</span>
                <span
                  className={styles.textCodeDescription}
                  data-test="data-group"
                >
                  - {functionalOptionCodeMappings[code].description}
                  {++i === countFunctionalCode ? null : ','}
                </span>
              </span>
            ))}
          </div>
        )}
        <span className={styles.separatorMargin}>
          <span className={styles.verticalSeparator}>|</span>
          <span>+ {formatUpcharge}</span>
          <span className={styles.verticalSeparator}>|</span>
          <span>
            {functionalGroupQuantity} {unitsString}
          </span>
        </span>
      </div>
      {inReviewView && (
        <DesignOptionFilters
          isMini={mini}
          functionalGroupId={functionalGroupId}
          isOpen={areFiltersVisible}
          toggleFilters={onSearchWithinGroup}
          onRemoveFilter={onRemoveFilter}
          modelId={modelId}
          availableOptions={designOptions}
        />
      )}
      <div className={styles.functionalGroupMain}>
        <div className={mini ? styles.columnMiniLabels : styles.columnLabels}>
          <span className={styles.designPackageColumn}>
            {designPackageString}
          </span>
          <span className={styles.column}>{priceBrandString}</span>
          <span className={styles.skinnyColumn}>{totalPriceString}</span>
          <span className={styles.column}>{suggestedString}</span>
          <span className={styles.skinnyColumn}>{quantityString}</span>
          <span className={styles.skinnyColumn}>{priorityHeader}</span>
          <span className={styles.skinnyColumn} />
          <span className={styles.buttonColumn} />
        </div>
      </div>
      {inReviewView &&
        hasInReviewTemplates &&
        visibleTemplateIds.map(templateId =>
          hasDuplicate && duplicateTemplateId === templateId ? (
            <span className={styles.emptyPadding}>
              <Template
                key={templateId}
                templateId={templateId}
                functionalGroupCodes={functionalGroupCodes}
                modelId={modelId}
              />
              <Template
                key={`${duplicateTemplateId}-duplicate`}
                templateId={duplicateTemplateId}
                functionalGroupCodes={functionalGroupCodes}
                modelId={modelId}
                isDuplicate={true}
              />
            </span>
          ) : (
            <Template
              key={templateId}
              templateId={templateId}
              functionalGroupCodes={functionalGroupCodes}
              modelId={modelId}
            />
          ),
        )}
      <div>
        {inReviewView && functionalGroupTemplates.length ? (
          <div
            className={styles.functionalGroupDynamicScroll}
            id="template"
            onScroll={isInViewport}
            data-test="scrollingTemplates"
            data-testid="app-header"
          >
            {functionalGroupTemplates.map(templateId => (
              <SearchTemplate
                key={templateId}
                templateId={templateId}
                functionalGroupCodes={functionalGroupCodes}
                modelId={modelId}
              />
            ))}
          </div>
        ) : null}
        {activeFilters[functionalGroupId] &&
        !functionalGroupTemplates.length ? (
          <div className={styles.noResultsContainer}>
            {noSearchResultsNotice}
          </div>
        ) : null}
        {inReviewView && !hasInReviewTemplates && !areFiltersVisible && (
          <div className={mini ? styles.emptyMiniBundle : styles.emptyBundle}>
            <span>{noInReviewTemplatesNotice}</span>
            {/*
              Client does not want Find as part of MVP.
              Still needs to be refactored after Model/ModelTemplateHeader changes
              to be able to apply the search filter tags
             */}
            {/*!searchView && (
              <button
                className={styles.findMore}
                style={buttonTheming}
                onClick={onFindMore}
              >
                {findMore}
              </button>
            )*/}
          </div>
        )}
        {!inReviewView &&
          hasSubmittedTemplates &&
          submittedTemplateIds.map(templateId => (
            <TemplateViewOnly
              key={templateId}
              templateId={templateId}
              functionalGroupCodes={functionalGroupCodes}
              modelId={modelId}
            />
          ))}
        {!inReviewView && !hasSubmittedTemplates && (
          <div className={styles.emptyBundle}>{noSubmittedTemplatesNotice}</div>
        )}
        {searchView &&
          matchingSearchTemplates.map(templateId => (
            <SearchTemplate
              key={templateId}
              templateId={templateId}
              functionalGroupCodes={functionalGroupCodes}
              modelId={modelId}
            />
          ))}
        <Warning
          isOpen={isWarningVisible}
          primaryAction={hideWarning}
          handleClose={hideWarning}
          secondaryAction={clearGlobalFilters}
        />
      </div>
    </div>
  );
};

export default enhance(FunctionalGroup);
